/**
 * Fonte única para URLs que não devem passar por refresh de token / Bearer do Keycloak.
 * Usado por `bearerExcludedUrls`, `shouldUpdateToken` e (parcialmente) pelo interceptor de spinner.
 */

export const FX_RATES_API_URL_MARKER = 'fxratesapi.com';

const ANONYMOUS_HTTP_MARKERS = ['viacep.com.br', 'api.fxratesapi.com', FX_RATES_API_URL_MARKER] as const;

/** Base do servidor Keycloak sem barra final — comparação estável com `req.url`. */
export function normalizeKeycloakServerBase(url: string): string {
  return url.replace(/\/$/, '');
}

/** Lista para `KeycloakService.init({ bearerExcludedUrls })` (substring match no URL do pedido). */
export function buildKeycloakBearerExcludedUrls(keycloakServerUrl: string): string[] {
  const trimmed = normalizeKeycloakServerBase(keycloakServerUrl);
  return Array.from(
    new Set<string>(['/assets', keycloakServerUrl, trimmed, ...ANONYMOUS_HTTP_MARKERS])
  );
}

/**
 * Pedidos a estes destinos não devem disparar `updateToken` (alinhado a `bearerExcludedUrls`).
 * Chamado depois das checagens O(1) de autenticação / OPTIONS / TTL em `shouldAttemptKeycloakTokenRefresh`.
 */
export function httpUrlSkipsKeycloakBearerRefresh(url: string, kcBase: string): boolean {
  if (url.includes('/assets/') || url.includes('/assets?')) {
    return true;
  }
  for (const m of ANONYMOUS_HTTP_MARKERS) {
    if (url.includes(m)) {
      return true;
    }
  }
  if (kcBase && url.startsWith(kcBase)) {
    return true;
  }
  return false;
}

export function isFxRatesHttpUrl(url: string): boolean {
  return url.includes(FX_RATES_API_URL_MARKER);
}
